/*============ Toggle Offer Controller
 ================================*/
angular
  .module('vppApp')
  .controller('toggleOfferController', toggleOfferController);

  toggleOfferController.$inject = ['$scope', 'vppConfig', 'apiFactory', '$state', '$log'];

  function toggleOfferController($scope, vppConfig, apiFactory, $state, $log) {

    let tabsAvailable = ["vehicle-offers.html", "cash-finance-offers.html"];
    $scope.showTab;
    $scope.currentTab = 0;
    $scope.siteCode = vppConfig.folderPath;
    $scope.siteName = vppConfig.siteNames[$scope.siteCode];

    $scope.loadOfferTab = function (index){
      if(index != undefined){
        $scope.currentTab = index;
        $scope.showTab = 'non-content/components/' + tabsAvailable[index];
      } else {
        $scope.showTab = 'non-content/components/' + tabsAvailable[$scope.currentTab];
      }
    }

    $scope.loadOfferTab();
  };